import Box from '@zenbusiness/zui/Box';
import DialogActions from '@zenbusiness/zui/DialogActions';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const ContentStack = superstyled({
  tag: Stack,
  name: 'RequestSuccessful',
  slot: 'ContentStack',
  styles: ({ theme }) => ({ textAlign: 'center', paddingBlock: theme.spacing(2) }),
});

export const IllustrationImage = superstyled({
  tag: Box,
  name: 'RequestSuccessful',
  slot: 'IllustrationImage',
  styles: ({ theme }) => ({ width: '50%', maxWidth: 256, marginBottom: theme.spacing(3) }),
});

export const TitleText = superstyled({
  tag: Text,
  name: 'RequestSuccessful',
  slot: 'TitleText',
  styles: ({ theme }) => ({ marginBottom: theme.spacing(1) }),
});

export const ActionsContainer = superstyled({
  tag: DialogActions,
  name: 'RequestSuccessful',
  slot: 'ActionsContainer',
  styles: ({ theme }) => ({
    justifyContent: 'flex-end',
    paddingInline: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  }),
});
